import React from "react";
import { useResultingListForm } from "../../providers/ResultingListProvider";
import { checkIsControlEnabled } from "./helpers/AddonsHelpers";
import type { ListViewSectionGroupStrict } from "stores/product";

type Props = {
  group: ListViewSectionGroupStrict;
  groupIndex: number;
};

export const DynamicGroup: React.FC<Props> = ({ group, groupIndex }) => {
  const { values, setValue, setRadioGroupValue } = useResultingListForm();

  const inputType = group?.groupControlType === "Radio" ? "radio" : "checkbox";

  const radioIds = group?.controls?.map((c) => c?.id);

  const handleChange = (
    controlId: string,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (group.groupControlType === "Radio" && radioIds) {
      setRadioGroupValue(radioIds, controlId);
    } else {
      setValue(controlId, e.target.checked);
    }
  };

  return (
    <div className="mb-2" id={`addon-group-${groupIndex}`}>
      <div className="mb-2">
        {group.title && <strong>{group?.title}</strong>}
      </div>
      {group?.controls?.map((control) => (
        <div key={control?.id} className="form-check d-flex flex-nowrap">
          <input
            type={inputType}
            name={`group-${groupIndex}-${control?.id}`}
            className="form-check-input"
            checked={(values[control?.id] ?? control?.boolValue) as boolean}
            disabled={
              control?.enabledBy
                ? !checkIsControlEnabled(control?.enabledBy, values)
                : !control?.enabled
            }
            onChange={(e) => handleChange(control?.id, e)}
            id={`addon-control-${control?.id}`}
          />

          <label
            className="form-check-label"
            id={`addon-control-label-${control?.id}`}
          >
            {control?.title}
          </label>
        </div>
      ))}
    </div>
  );
};
